module.exports = __webpack_public_path__ + "static/media/instructivova6.a85148dc.png";